import * as Models from "../.";

export interface IMarketAssumedValuesModel {
    market: Models.CostCalculation.Market.Market;
    marketCaps: Models.CostCalculation.MarketCap.MarketCap;

    termLength: number;
    transactionFeePercent: number;
    developmentFeePercent: number;
    percentDegradation: number;
    operationManagementCostPerKw: number;
    operationManagementEscalator: number;
    operationManagementFreeStartYears: number;
    insuranceRate: number;
    insuranceEscalator: number;
    assetManagementFeePerKw: number;
    investmentTaxCreditPercent: number;
    igsCorporateTaxRate: number;
    bonusDepreciationPercent: number;

    percentYield: number;
    cellServiceFreeStartYears: number;
    cellServiceEscalator: number;
    creditCardFeePercent: number;
    inverterReplacementCostPerWatt: number;
    inverterReserveStartYear: number;
    inverterReplacementYear: number;
    monthsFromContractSigningToMechanicalCompletion: number;
    monthsFromMechanicalCompletionToPto: number;
    percentInvestmentAtContractSigning: number;
    percentInvestmentAtMechanicalCompletion: number;
    percentInvestmentAtPto: number;
    systemRemovalNetRevenuePerWatt: number;
    defaultContractSignDate: Date;

    annualProductionCap: number;
    systemSizeCap: number;
    yieldCap: number;

    srecFactor: number;
    srecCommissionPercent: number;
    srecMintingPeriodLength: number;
    numberOfSrecYears: number;
    numberOfTier1SrecMonths: number;
    srecStartMonth: number;
    
    tier1SrecCurve: ISrecPriceCurves;
    tier2SrecCurve: ISrecPriceCurves;

    numberOfPbiMonths: number;

    monthCbiIsApplied: number;

    prepaidSrecCashflowPercents: IPrepaidSrecCashflowPercent[];
    
    acceleratedDepreciationPoints: IAcceleratedDepreciationPoints[];

    srecPriceIntervals: ISrecPriceInterval[];
    relativeSrecSellingMonths: number[];
    MonthlyProductionLookup: Models.CostCalculation.MonthlyProductionLookup.MonthlyProductionLookup;

    taxEquityDetails: Models.CostCalculation.TaxEquityDetails.ITaxEquityDetails;
    taxAndCashEquityDetails: Models.CostCalculation.TaxAndCashEquityDetails.ITaxAndCashEquityDetails;

    incentiveType: Models.CostCalculation.IncentiveType.IIncentiveType;
    inUse: boolean;
}

export interface IAcceleratedDepreciationPoints {
    term: number;
    percent: number;
}

export class AcceleratedDepreciationPoints implements IAcceleratedDepreciationPoints {
    term: number;
    percent: number;
}

export interface ISrecPricePoints {
    year: number;
    srecPriceAtTerm: number;
}

export class SrecPricePoints implements ISrecPricePoints {
    year: number;
    srecPriceAtTerm: number;
}

export interface ISrecPriceInterval {
    srecPrice: number;
    startDate: Date;
    endDate: Date;
}

export class SrecPriceInterval implements ISrecPriceInterval {
    srecPrice: number;
    startDate: Date;
    endDate: Date;
}

export interface ISrecPriceCurves {
    name: string;
    code: string;
    srecPriceIntervals: ISrecPriceInterval[];
    inUse: boolean;
    availableForMarketAssociation: boolean;
}

export class SrecPriceCurves implements ISrecPriceCurves {
    name: string;
    code: string;
    srecPriceIntervals: ISrecPriceInterval[];
    inUse: boolean;
    availableForMarketAssociation: boolean;
}

export interface ICloneSrecPriceCurveResponse {
    srecPriceCurvesModel: ISrecPriceCurves;
    success: boolean;
    errors: string[];
}

export class CloneSrecPriceCurveResponse implements ICloneSrecPriceCurveResponse {
    srecPriceCurvesModel: ISrecPriceCurves;
    success: boolean;
    errors: string[];
}

export interface IPrepaidSrecCashflowPercent {
    cashflowNumber: number;
    srecPercent: number;
}

export class PrepaidSrecCashflowPercent implements IPrepaidSrecCashflowPercent {
    cashflowNumber: number;
    srecPercent: number;
}


